import React, { useContext, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
// components
import { Confetti, Loading, Msg, Question } from '../../components'
// functions
import shuffleArr from '../../functions/suffle';
import { useApi } from '../../hooks/apiReq'
// style
import styles from "./style.module.scss"
import gameoverImg from "../../media/gameover.svg"
// import start from "../../media/start.svg"
// ts
import { QuestionType, QuestionState } from './types'
import { popup_context } from "../../hooks/usePopUp"


const Quiz: React.FC = () => {
   const
      [searchParams] = useSearchParams(),
      { quesAmount, category, difficulty } = Object.fromEntries(searchParams),
      path = `https://opentdb.com/api.php?amount=${quesAmount}&category=${category}&difficulty=${difficulty}`,
      { loading, error, data, createApi } = useApi({ path, method: "get" }),
      [currQuestion, setCurrQuestion] = useState<number>(0),
      [score, setScore] = useState<number>(0),
      [userAnswers, setUserAnswers] = useState<string[]>([]),
      [dataToPrint, setDataToPrint] = useState<QuestionState[]>([]),
      [gameOver, setGameOver] = useState<boolean>(false),
      lastQuestion = currQuestion === Number(quesAmount) - 1,
      setPop = useContext(popup_context)

   // console.log(category, difficulty, quesAmount, error, data, dataToPrint);

   useEffect((): void => {
      if (data) {
         setDataToPrint(data?.results?.map((q: QuestionType) =>
            ({ ...q, answers: shuffleArr([...q.incorrect_answers, q.correct_answer]) })
         ))
      }
   }, [data])

   const startQuiz = (): void => {
      createApi()
      setDataToPrint([])
      setScore(0)
      setUserAnswers([])
      setCurrQuestion(0)
      setGameOver(false)
      // setPop(<Msg image={start} text={`good luck!!!`} />)
   }

   const gameOverHandler = (): void => {
      setPop(<> <Msg image={gameoverImg} text={`your score is ${score} out of ${quesAmount}`} /> <Confetti /> </>)
      setGameOver(true)
   }

   const nextQuestion = () => !lastQuestion ? setCurrQuestion(currQuestion + 1) : gameOverHandler()

   const checkAnswer = async (text: string) => {
      setUserAnswers([...userAnswers, text])
      if (text === dataToPrint[currQuestion].correct_answer) setScore(score + 1)
      setTimeout(nextQuestion, 3000);
   }

   return (
      <div className={`${styles.container} d-flex`}>

         {loading ? <Loading /> : error ? <p>{error}</p> :
            <>
               <div className="card">
                  <h1>good luck!</h1>
                  <h5> <span>category:</span>  {dataToPrint[0]?.category} </h5>
                  <h5><span>difficulty:</span>  {difficulty}</h5>
                  <h5><span>your score is :</span>  {score}</h5>
               </div>

               <div className={`${styles.all} card d-flex`}>
                  {dataToPrint.length &&
                     <Question
                        index={currQuestion}
                        q={dataToPrint[currQuestion]}
                        userAnswer={userAnswers[currQuestion]}
                        checkAnswer={checkAnswer} />}

                  {gameOver &&
                     <div className={`d-flex btnbox  ${styles.controlBtn}`}>
                        <button onClick={startQuiz}>restart</button>
                        <a href='/start'>re-select questions</a>
                     </div>}
               </div>
            </>
         }
      </div>
   )
}

export default Quiz
